import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
interface NorthFortMyersFreeInspectionCtaProps {
  description?: string;
}
export default function NorthFortMyersFreeInspectionCta({
  description = "North Fort Myers families trust us to protect their homes from local pest threats year-round"
}: NorthFortMyersFreeInspectionCtaProps) {
  return <section id="north-fort-myers-free-inspection-cta" className="bg-secondary text-secondary-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 flex flex-col items-center text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default mb-6 max-w-3xl">
          Free Inspection in North Fort Myers
        </h2>
        <p className="text-lg md:text-xl mb-8 max-w-2xl opacity-90 font-sans">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Button asChild size="lg" className="bg-background text-foreground hover:bg-background/90 font-bold text-lg h-14 px-8">
            <Link to="/Contact">
              Schedule Inspection
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="bg-transparent border-2 border-secondary-foreground text-secondary-foreground hover:bg-secondary-foreground hover:text-secondary font-bold text-lg h-14 px-8">
            <Link to="tel:9418880485">
              <Phone className="mr-2 h-5 w-5" />
              941-888-0485
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}